import { Outlet } from 'react-router-dom'
import AlertsNav from './AlertsNav'

export default function AlertsLayout() {
  return (
    <div className="flex h-[calc(100vh-4rem)] -mx-4 sm:-mx-6 lg:-mx-8 -my-6">
      <aside className="w-64 shrink-0 bg-white border-r border-gray-200 overflow-y-auto">
        <div className="p-4 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900 whitespace-nowrap">Alerts</h1>
        </div>
        <AlertsNav />
      </aside>

      <main className="flex-1 min-w-0 overflow-auto p-8 bg-gray-50">
        <Outlet />
      </main>
    </div>
  )
}
